export default __webpack_public_path__ + "static/headstand-fullheadstand-2-06b408633e1fce72454eb89ed0f7375c.jpg";